import { HelpOutline, Storefront } from "@mui/icons-material"
import { Link } from "react-router-dom"
import React, { Suspense } from "react"
import DarkModeIcon from "@mui/icons-material/DarkMode"
import LanguageSelector from "./LanguageSelector"
import LightModeIcon from "@mui/icons-material/LightMode"
import SocialMediaLinks from "./components/SocialMediaLinks"
import { UserQuickInfo } from "./UserQuickInfo"
import { UsersCounter } from "./components/UsersCounter"
import WysiwygIcon from "@mui/icons-material/Wysiwyg"
// import { useColorScheme } from "@mui/material/styles"
import { useNamespacedTranslation } from "./hooks/useNamespacedTranslation"
import { SupportInfo } from "./components/SupportInfo"
import { useUserStore } from "./components/stores/userStore"
import { DrawerContentView } from "react-ui-components/components/navigation/DrawerContentView"

const DownloadButtons = React.lazy(() =>
  import("./components/DownloadButtons").then((module) => ({ default: module.DownloadButtons })),
)

const WinBoxTicketsGuide = React.lazy(() => import("./components/WinBoxTicketsGuide"))

export const DrawerContent: React.FC = () => {
  const [guideOpen, setGuideOpen] = React.useState(false)
  const openGuide = React.useCallback(() => setGuideOpen(true), [])
  const closeGuide = React.useCallback(() => setGuideOpen(false), [])
  const { mode, setMode, displayContentConfig } = useUserStore()
  const { t } = useNamespacedTranslation(['common'])
  const handleThemeToggle = React.useCallback(() => {
    setMode(mode === "light" ? "dark" : "light")
  }, [mode, setMode])
  const themeToggleIcon = React.useMemo(() => {
    if (mode === "light") {
      return <LightModeIcon />
    }

    if (mode === "system") {
      return <WysiwygIcon />
    }

    return <DarkModeIcon />
  }, [mode])
  const navItems = React.useMemo(
    () => [
      {
        key: "affiliates",
        href: "/affiliates",
        icon: <Storefront />,
        label: t("Businesses", { defaultValue: "Businesses" }),
        linkComponent: Link,
      },
      {
        key: "win-box-guide",
        icon: <HelpOutline />,
        label: t("Win Box and tickets guide"),
        onClick: openGuide,
      },
    ],
    [t, openGuide],
  )

  return (
    <>
      <DrawerContentView
        userInfoSlot={<UserQuickInfo />}
        usersCounterSlot={<UsersCounter variant="text" left={false} size="small" />}
        showDownload={Boolean(displayContentConfig?.displayDownload)}
        downloadLabel={t`Download the App`}
        downloadSlot={
          displayContentConfig?.displayDownload ? (
            <Suspense fallback={null}>
              <DownloadButtons revertColor />
            </Suspense>
          ) : null
        }
        navItems={navItems}
        socialSlot={<SocialMediaLinks />}
        supportSlot={<SupportInfo className="m-1" />}
        themeToggleIcon={themeToggleIcon}
        onThemeToggle={handleThemeToggle}
        languageSlot={<LanguageSelector />}
      />
      {guideOpen && (
        <Suspense fallback={null}>
          <WinBoxTicketsGuide onClose={closeGuide} />
        </Suspense>
      )}
    </>
  )
}
